export const UploadCloudIcon = ({
  height = 24,
  width = 24,
  strokeWidth = 2,
}: {
  height?: number;
  width?: number;
  strokeWidth?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3486_6759)">
      <path
        d="M16 16L12 12L8 16"
        stroke="currentcolor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12V21"
        stroke="currentcolor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.39 18.39C21.3653 17.8583 22.1358 17.0169 22.5798 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9434 10.7355 21.0666 10.0534C20.1898 9.37138 19.1108 9.00073 18 9H16.74C16.4373 7.82924 15.8731 6.74233 15.0899 5.82099C14.3067 4.89965 13.3248 4.16785 12.2181 3.68061C11.1113 3.19336 9.90851 2.96336 8.70008 3.00788C7.49164 3.05241 6.30903 3.3703 5.24114 3.93766C4.17325 4.50503 3.24787 5.3071 2.53458 6.28358C1.82129 7.26006 1.33865 8.38554 1.12294 9.57539C0.90723 10.7653 0.964065 11.9885 1.28917 13.1533C1.61428 14.318 2.1992 15.3939 2.99996 16.3"
        stroke="currentcolor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16L12 12L8 16"
        stroke="currentcolor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3486_6759">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
